<template>
  <div>
    <div class="sidebar-container mt-50px d-flex" style="position: relative">
      <button class="btn-primary"><magnify-icon /></button
      ><input
        class="input-style ml-3px"
        placeholder="Entrez le nom de l'entreprise"
        v-model="searchByKeyword"
        @keyup="searchByKeywordFunction()"
      />
      <div class="emptyer" @click="emptyThat">
        <close-icon class="colorLightgrey"></close-icon>
      </div>
    </div>
    <slide-y-up-transition>
      <div
        class="sidebar-container mt-10px"
        v-if="searchByKeyword !== '' && dropdownActive"
      >
        <div class="choice-key-word">
          <div
            v-show="searchByKeywordResult.length == 0"
            class="choice-key-word-item"
          >
            Aucun résultats
          </div>
          <div
            class="choice-key-word-item"
            v-for="(result, index) in searchByKeywordResult"
            @click="zoomToThisResult(result)"
            :key="index"
            v-html="result.properties.name"
          ></div>
        </div>
      </div>
    </slide-y-up-transition>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      searchByKeyword: '',
      searchByKeywordResult: [],
      dropdownActive: false
    }
  },
  props: {
    geojson: {
      type: Object
    },
    lmap: {
      type: Object
    },
    initial: String
  },
  methods: {
    emptyThat () {
      this.searchByKeyword = ''
    },
    searchByKeywordFunction: function () {
      this.searchByKeywordResult = this.geojson.features.filter((element) =>
        element.properties.name
          .toLowerCase()
          .includes(this.searchByKeyword.toLowerCase())
      )
      this.dropdownActive = true
    },
    zoomToThisResult: function (feature) {
      this.$router.push('/?name=' + feature.properties.name)
      this.lmap.flyTo(
        [feature.geometry.coordinates[1], feature.geometry.coordinates[0]],
        17
      )
      this.searchByKeyword = feature.properties.name
      this.searchByKeywordResult = []
      this.dropdownActive = false
      this.$emit('input', feature)
    }
  },
  mounted () {
    this.searchByKeyword = this.initial
    if (this.searchByKeyword) {
      this.searchByKeywordFunction()
      this.zoomToThisResult(this.searchByKeywordResult[0])
    }
  }
}
</script>
<style>
.emptyer {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchKeyWord.vue